var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box box--project"},[_c('div',{staticClass:"box-inner"},[_c('router-link',{staticClass:"box-title",attrs:{"to":("/projects/" + (_vm.box.idProject))}},[_vm._v(_vm._s(_vm.box.name))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }